import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import classNames from 'utils/classNames';

const styles = require('./errorMessage.css');

export interface ErrorMessageInterface {
  message: string;
  style?: {};
  className?: string;
  animated?: boolean;
}

const spanProps = (props: ErrorMessageInterface) => ({
  children: props.message,
  style: props.style,
  className: classNames({
    inlineError: true,
    [props.className]: !!props.className,
  }),
});

/**
 * @deprecated
 */
const ErrorMessage = (props: ErrorMessageInterface): JSX.Element =>
  props.animated ? (
    <AnimatePresence>
      <motion.span
        {...spanProps(props)}
        key="span"
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'max-content' }}
        exit={{ opacity: 0, height: 0 }}
      />
    </AnimatePresence>
  ) : (
    <span {...spanProps(props)} />
  );

export default ErrorMessage;
